import { getLanguageFromPath, getLanguageUrls } from './localeRoutes';

// Utility to manage canonical and language alternate URLs dynamically.

const normalizePath = (path = '') => {
  if (!path || path === '/') {
    return '/';
  }

  const cleanPath = path.split('?')[0].split('#')[0];
  const withoutTrailingSlash = cleanPath.replace(/\/+$/, '');

  return withoutTrailingSlash || '/';
};

export const updateCanonicalUrl = (path = '') => {
  const baseUrl = 'https://radixtechs.com';
  const canonicalPath = normalizePath(path);
  const canonicalUrl = canonicalPath === '/' ? baseUrl : `${baseUrl}${canonicalPath}`;
  
  // Find existing canonical link or create new one
  let canonicalLink = document.querySelector('link[rel="canonical"]');
  
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    document.head.appendChild(canonicalLink);
  }
  
  canonicalLink.href = canonicalUrl;
  
  // Also update Open Graph URL
  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) {
    ogUrl.setAttribute('content', canonicalUrl);
  }
  
  // Update Twitter URL
  const twitterUrl = document.querySelector('meta[property="twitter:url"]');
  if (twitterUrl) {
    twitterUrl.setAttribute('content', canonicalUrl);
  }
};

const updateAlternateLink = (hreflang, href) => {
  let link = document.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);

  if (!link) {
    link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = hreflang;
    document.head.appendChild(link);
  }

  link.href = href;
};

export const setSeoLinksForRoute = (pathname) => {
  const baseUrl = 'https://radixtechs.com';
  const normalizedPath = normalizePath(pathname);
  const urls = getLanguageUrls(normalizedPath);
  const absolute = path => path === '/' ? `${baseUrl}/` : `${baseUrl}${path}`;

  updateCanonicalUrl(normalizedPath);
  updateAlternateLink('en', absolute(urls.en));
  updateAlternateLink('ar', absolute(urls.ar));
  updateAlternateLink('x-default', absolute(urls.default));

  const language = getLanguageFromPath(normalizedPath);
  const ogLocale = document.querySelector('meta[property="og:locale"]');
  if (ogLocale) {
    ogLocale.setAttribute('content', language === 'ar' ? 'ar_AR' : 'en_US');
  }
};

// Update canonical URL based on current route
export const setCanonicalForRoute = (pathname) => {
  setSeoLinksForRoute(pathname);
};
